import type { Post } from "../types/post";

export const fallbackPosts: Post[] = [
  {
    id: "11111111-1111-4111-8111-111111111111",
    title: "دفتر صغير للهوامش",
    subtitle: "ملاحظة افتتاحية عن كتابة لا تطلب الضجيج",
    slug: "دفتر-صغير-للهوامش",
    excerpt:
      "في الكتابة الهادئة مساحة لا تطلب الانتباه، لكنها تحفظ ما لا نريد أن يضيع.",
    content: `# دفتر صغير للهوامش

هناك نوع من الكتابة لا يريد أن يتحول إلى إعلان. لا يبحث عن ضجيج، ولا يطارد سرعة اليوم. يكتفي بأن يكون ورقة مطوية في جيب المعنى.

في الهوامش تتسع الجملة لشيء من الصمت. نكتب كي نرى الفكرة وهي تتحرك ببطء، وكي لا نتركها وحيدة في ازدحام الذاكرة.

> ليست كل ملاحظة وعدا بمقال. بعضها مجرد أثر قراءة، أو طريقة لطيفة للنجاة من النسيان.

هذا المكان تجربة في أن تكون الكتابة أخف من المنصة، وأعمق من المنشور العابر. دفتر شخصي، مفتوح بما يكفي للقراءة، ومغلق بما يكفي ليحافظ على نبرته.`,
    content_format: "markdown",
    language: "ar",
    direction: "rtl",
    status: "published",
    visibility: "public",
    content_type: "essay",
    category: "أسئلة فلسفية ليست للإجابة",
    cover_image_url: null,
    tags: ["كتابة", "هوامش", "قراءة"],
    font_family: "noto-naskh",
    reader_theme: "paper",
    reading_time_minutes: 2,
    is_featured: true,
    created_at: "2026-05-14T12:00:00.000Z",
    updated_at: "2026-05-20T12:00:00.000Z",
    published_at: "2026-05-20T12:00:00.000Z"
  },
  {
    id: "22222222-2222-4222-8222-222222222222",
    title: "عن بطء القراءة",
    subtitle: "حين لا تكون القراءة سباقا",
    slug: "عن-بطء-القراءة",
    excerpt:
      "ليست القراءة البطيئة كسلا، بل طريقة لإعادة الوقت إلى الجملة وإعادة الجملة إلى صاحبها.",
    content: `# عن بطء القراءة

تبدو القراءة السريعة إنجازا جيدا في زمن يريد أن يحسب كل شيء. لكنها تترك أحيانا ظلا باردا: نعرف أننا مررنا على النص، ولا نعرف إن كان النص قد مر بنا.

القراءة البطيئة ليست دفاعا ضد العصر، ولا حنينا إلى زمن أكثر نقاء. هي فقط اختيار إيقاع يناسب بعض الكتب وبعض الأسئلة.

## ما الذي يحدث عندما نبطئ؟

- نلاحظ تركيب الجملة قبل خلاصتها.
- نسمع نبرة الكاتب لا فكرته فقط.
- نمنح الذاكرة فرصة أن تعمل دون استعجال.

في النهاية، ليست كل قراءة سباقا. بعض الصفحات لا تفتح معناها إلا حين نتركها تتمشى داخلنا قليلا.`,
    content_format: "markdown",
    language: "ar",
    direction: "rtl",
    status: "published",
    visibility: "public",
    content_type: "article",
    category: "هوامش القراءة",
    cover_image_url: "https://picsum.photos/seed/slow-reading/800/600?grayscale",
    tags: ["قراءة", "وقت"],
    font_family: "amiri",
    reader_theme: "paper",
    reading_time_minutes: 3,
    is_featured: false,
    created_at: "2026-05-02T12:00:00.000Z",
    updated_at: "2026-05-08T12:00:00.000Z",
    published_at: "2026-05-08T12:00:00.000Z"
  },
  {
    id: "66666666-6666-4666-8666-666666666666",
    title: "في مديح الكتابة الناقصة",
    subtitle: "المسودة بيت أول للفكرة",
    slug: "في-مديح-الكتابة-الناقصة",
    excerpt:
      "بعض النصوص تحتاج أن تبقى ناقصة قليلا، كي تظل صادقة قبل أن تصير مكتملة.",
    content: `# في مديح الكتابة الناقصة

تبدأ الفكرة دائما أوسع من قدرتنا على قولها. لذلك تولد الجملة الأولى ناقصة، لا لأننا قصّرنا، بل لأن المعنى ما زال يتنفس.

نخاف من النقص فنسارع إلى الصقل، ونحن لم نسمع بعد ما تريد المسودة أن تقوله. الصقل المبكر يجمّل النص ويسرق منه ارتباكه الجميل.

> دع للنص هامشا من التردد. التردد ليس ضعفا، بل علامة على أن السؤال أكبر من إجابة سريعة.

اكتب الناقص، واتركه ليلة. ما يبقى حيا في الصباح يستحق أن يكتمل.`,
    content_format: "markdown",
    language: "ar",
    direction: "rtl",
    status: "published",
    visibility: "public",
    content_type: "essay",
    category: "هوامش القراءة",
    cover_image_url: null,
    tags: ["كتابة", "مسودات"],
    font_family: "noto-naskh",
    reader_theme: "paper",
    reading_time_minutes: 2,
    is_featured: false,
    created_at: "2026-04-18T12:00:00.000Z",
    updated_at: "2026-04-22T12:00:00.000Z",
    published_at: "2026-04-22T12:00:00.000Z"
  },
  {
    id: "77777777-7777-4777-8777-777777777777",
    title: "ما يتركه النص على الطاولة",
    subtitle: "",
    slug: "ما-يتركه-النص-على-الطاولة",
    excerpt: "اقتباس قصير عن الكرم الخفي في الكتابة الجيدة.",
    content: "كل نص جيد يترك على الطاولة أكثر مما يأخذ منها؛ يمنحك سؤالا، ويأخذ منك عجلتك.",
    content_format: "plain",
    language: "ar",
    direction: "rtl",
    status: "published",
    visibility: "public",
    content_type: "quote",
    category: "نصوص قصيرة",
    cover_image_url: null,
    tags: ["اقتباسات"],
    font_family: "amiri",
    reader_theme: "paper",
    reading_time_minutes: 1,
    is_featured: false,
    created_at: "2026-04-12T12:00:00.000Z",
    updated_at: "2026-04-12T12:00:00.000Z",
    published_at: "2026-04-12T12:00:00.000Z"
  },
  {
    id: "88888888-8888-4888-8888-888888888888",
    title: "ضوء على المكتب وحده",
    subtitle: "في عادة الجلوس مع الصفحة",
    slug: "ضوء-على-المكتب-وحده",
    excerpt:
      "ليست الطقوس ترفا، بل طريقة لطيفة لإقناع العقل بأن الوقت الآن للكتابة.",
    content: `# ضوء على المكتب وحده

لكل كاتب طقس صغير: فنجان، ضوء خافت، دفتر لا يراه أحد. تبدو هذه التفاصيل زائدة، لكنها في الحقيقة جسر هادئ بين فوضى اليوم وصفاء الصفحة.

حين أُشعل ضوء المكتب وحده، أقول للعقل بلا كلمات: لقد بدأنا. وما إن تبدأ اليد بالحركة حتى يتراجع التشتت خطوة إلى الوراء.

ليست الكتابة إلهاما ينتظر، بل عادة نرتّب لها مكانا. والمكان حين يتكرر، يصير وعدا.`,
    content_format: "markdown",
    language: "ar",
    direction: "rtl",
    status: "published",
    visibility: "public",
    content_type: "article",
    category: "أسئلة فلسفية ليست للإجابة",
    cover_image_url: "https://picsum.photos/seed/desk-light/800/600?grayscale",
    tags: ["طقوس", "كتابة"],
    font_family: "amiri",
    reader_theme: "paper",
    reading_time_minutes: 2,
    is_featured: false,
    created_at: "2026-03-26T12:00:00.000Z",
    updated_at: "2026-03-30T12:00:00.000Z",
    published_at: "2026-03-30T12:00:00.000Z"
  },
  {
    id: "99999999-9999-4999-8999-999999999999",
    title: "ثلاث ملاحظات قبل النوم",
    subtitle: "هوامش متفرقة",
    slug: "ثلاث-ملاحظات-قبل-النوم",
    excerpt: "ملاحظات صغيرة لا تطمح إلى نتيجة، تكفيها أن تُقال.",
    content: `# ثلاث ملاحظات قبل النوم

ليس كل ما نفكر فيه يحتاج إلى مقال. بعض الأفكار تكتفي بأن تُدوّن سطرا واحدا قبل أن تنطفئ.

1. ما نؤجّله من القراءة لا يضيع، لكنه يتغيّر حين نعود إليه.
2. أصعب جملة في النص هي التي تحذفها بهدوء.
3. الصمت في آخر الفقرة جزء من المعنى، لا فراغ بعده.

أكتب هذه الهوامش لا لأتذكرها، بل لأنام وقد وضعتها خارج رأسي.`,
    content_format: "markdown",
    language: "ar",
    direction: "rtl",
    status: "published",
    visibility: "public",
    content_type: "note",
    category: "نصوص قصيرة",
    cover_image_url: null,
    tags: ["هوامش", "ملاحظات"],
    font_family: "noto-naskh",
    reader_theme: "paper",
    reading_time_minutes: 1,
    is_featured: false,
    created_at: "2026-03-12T12:00:00.000Z",
    updated_at: "2026-03-15T12:00:00.000Z",
    published_at: "2026-03-15T12:00:00.000Z"
  },
  {
    id: "44444444-4444-4444-8444-444444444444",
    title: "مسودة لم تكتمل بعد",
    subtitle: "",
    slug: "مسودة-لم-تكتمل-بعد",
    excerpt: "مثال لمسودة تظهر داخل الاستوديو فقط عند تفعيل وضع العرض المحلي.",
    content: `# مسودة لم تكتمل بعد

هذه مسودة تجريبية لتوضيح حالة المقال غير المنشور داخل لوحة التحرير.`,
    content_format: "markdown",
    language: "ar",
    direction: "rtl",
    status: "draft",
    visibility: "private",
    content_type: "thought",
    category: null,
    cover_image_url: null,
    tags: ["مسودات"],
    font_family: "noto-naskh",
    reader_theme: "paper",
    reading_time_minutes: 1,
    is_featured: false,
    created_at: "2026-04-28T12:00:00.000Z",
    updated_at: "2026-04-29T12:00:00.000Z",
    published_at: null
  }
];
